/**
 * Exports drawer-related design tokens
 */

// True to set all corners to 0 border radius
export const clearBorderRadius = true;

export const defaultSize = 'small';
export const defaultSide = 'right';